import { APIClient } from "../helpers/api_helper";
import {
  ApiResponse,
  PaginatedApiResponse,
  PaginationParams,
} from "../types/api";
import {
  CatalogCategory,
  CreateCatalogCategoryPayload,
  UpdateCatalogCategoryPayload,
} from "../types/catalogCategory";

const api = new APIClient();

const RESOURCE = "/catalog-categories";

export interface CatalogCategoryListParams extends PaginationParams {
  is_active?: boolean;
}

export const getCatalogCategories = (
  params?: CatalogCategoryListParams
): Promise<PaginatedApiResponse<CatalogCategory>> =>
  api.get<PaginatedApiResponse<CatalogCategory>>(RESOURCE, params);

export const getCatalogCategory = (
  id: number
): Promise<ApiResponse<CatalogCategory>> =>
  api.get<ApiResponse<CatalogCategory>>(`${RESOURCE}/${id}`);

export const createCatalogCategory = (
  payload: CreateCatalogCategoryPayload
): Promise<ApiResponse<CatalogCategory>> =>
  api.create<ApiResponse<CatalogCategory>>(RESOURCE, payload);

export const updateCatalogCategory = (
  id: number,
  payload: UpdateCatalogCategoryPayload
): Promise<ApiResponse<CatalogCategory>> =>
  api.update<ApiResponse<CatalogCategory>>(`${RESOURCE}/${id}`, payload);

export const deleteCatalogCategory = (
  id: number
): Promise<ApiResponse<Record<string, never>>> =>
  api.delete<ApiResponse<Record<string, never>>>(`${RESOURCE}/${id}`);
